module.exports = __webpack_public_path__ + "img/desarrollo-1-760.cad6718c.webp";